<div *ngIf="workBookError">
  <div class="alert alert-primary" role="alert">
   Unable to retrieve the selected report
  </div>
</div>                                                                                                           
<div class="content" *ngIf="!customReportUrl">
  <div id="vizContainer" style="display: flex; justify-content: center"></div>
</div>
<div *ngIf="customReportUrl">
  <reportpdfviewer [url]="customReportUrl"></reportpdfviewer>
</div>
